import { render, staticRenderFns } from "./ClientesView.vue?vue&type=template&id=00694c9c&scoped=true"
import script from "./ClientesView.vue?vue&type=script&lang=js"
export * from "./ClientesView.vue?vue&type=script&lang=js"
import style0 from "./ClientesView.vue?vue&type=style&index=0&id=00694c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00694c9c",
  null
  
)

export default component.exports